import {
    StyleSheet
} from "react-native";
import type {
    SidebarMeasures,
    SidebarVariant
} from "../../type";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        flexDirection: "column",
        borderStyle: "solid",
        flexShrink: 0,
        minWidth: 0
    }
});

export const useStyles = ({
    isOverflow,
    measures,
    borders,
    variant,
    colors,
    spaces
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    spaces: NCoreUIKit.ActivePalette["spaces"];
    borders: NCoreUIKit.Borders;
    measures: SidebarMeasures;
    variant: SidebarVariant;
    isOverflow: boolean;
}) => {
    return {
        container: {
            paddingVertical: variant === "floating" ? measures.padding : spaces.spacingSm,
            borderTopColor: isOverflow ? colors.content.border.subtle : "transparent",
            paddingHorizontal: measures.padding,
            borderTopWidth: borders.separator,
            minHeight: measures.headerHeight,
            gap: spaces.spacingSm
        }
    };
};
export default stylesheet;
